@if (detailsForm.controls.dealType.value === 'brokerage') {
  <div class="brokerage-deal" gdColumns="minmax(0, 4fr) minmax(0, 2fr)" gdGap="30px"
    >
    <tc-brokerage-info-form
      [detailsForm]="detailsForm"
      (change)="onCurrencyChange()"
    ></tc-brokerage-info-form>
    <tc-brokerage-dates-form
      [dealForm]="dealForm"
      [dealViewRaw$]="dealViewRaw$"
    ></tc-brokerage-dates-form>
  </div>
}
@if (!mode) {
  <h4 class="tc-confirmation-status" [formGroup]="detailsForm" [gdColumns]="detailsForm.controls.dealType.value === 'brokerage' ? 'repeat(3, minmax(0, 1fr))' : 'repeat(2, minmax(0, 1fr))'" gdGap="50px">
    <div class="tc-parties-left" gdColumns="repeat(2, minmax(0, 1fr))">
      <div>
        @if (!detailsForm.controls.supplierConfirmedAt.value) {
          Supplier has not confirmed sale
        }
        @if (detailsForm.controls.supplierConfirmedAt.value) {
          Supplier confirmed sale <i class="fa fa-check"></i>
        }
      </div>
      <div>
        @if (isManager) {
          <mat-checkbox style="margin-right: 20px;" [checked]="!!detailsForm.controls.supplierConfirmedAt.value" [disabled]="!dealId" (change)="sellerConfirm()">
            Supplier contract
          </mat-checkbox>
        }
        <mat-checkbox [checked]="!!detailsForm.controls.woExportDocs.value" (change)="setWoExportDocs($event)">
          W/O export docs
        </mat-checkbox>
      </div>
    </div>
    @if (detailsForm.controls.dealType.value === 'brokerage') {
      <div class="tc-parties-right">
        @if (isDealConfirmedByBrokerageCustomer$ | async) {
          Brokerage party confirmed service <i class="fa fa-check"></i>
        } @else {
          Brokerage party has not confirmed service
        }
      </div>
    }
    <div class="tc-parties-right" gdColumns="repeat(2, minmax(0, 1fr))">
      <div>
        @if (!detailsForm.controls.buyerConfirmedAt.value) {
          Buyer has not confirmed purchase
        }
        @if (detailsForm.controls.buyerConfirmedAt.value) {
          Buyer confirmed purchase <i class="fa fa-check"></i>
        }
      </div>
      <div>
        @if (isManager) {
          <mat-checkbox [checked]="!!detailsForm.controls.buyerConfirmedAt.value" [disabled]="!dealId" (change)="buyerConfirm()">
            Buyer contract
          </mat-checkbox>
        }
      </div>
      <mat-checkbox formControlName="proformaNeeded">
        Proforma needed
      </mat-checkbox>
      <mat-checkbox formControlName="useCorpUsAddress">
        Use corporation US address
      </mat-checkbox>
    </div>
  </h4>
}

<div class="tc-deal-parties" gdColumns="repeat(2, minmax(0, 1fr))" gdGap="50px" [formGroup]="detailsForm">
  <div class="tc-parties-left" gdColumns="minmax(0, 2fr) minmax(0, 1fr) minmax(0, 1fr)" gdGap="15px">
    <tc-select-search placeholder="Supplier"
      [class.tc-portal-visible]="isSupplierPortalVisible$ | async"
      [group]="detailsForm" ctrlName="supplierId"
      [items]="suppliers$ | async" bindValue="id" bindLabel="name"
      (change)="supplierChanged$.next($safeNavigationMigration($event?.id))"
    ></tc-select-search>
    <mat-form-field [formGroup]="detailsForm">
      <mat-label>Supplier ref. number</mat-label>
      <input matInput formControlName="supplierRef" autocomplete="off">
    </mat-form-field>
    <tc-select-search placeholder="Country Of Origin"
      [group]="detailsForm" ctrlName="originCountryCode"
      [items]="countries$ | async" bindValue="code" bindLabel="name"
      (change)="onOriginCountryChange()"
    ></tc-select-search>

    <tc-select-search placeholder="Pickup" data-test="supplier-pickup-field"
      [group]="detailsForm" ctrlName="originLocationId"
      [items]="locations$ | async" bindValue="location_id" bindLabel="name"
      (change)="onOriginLocationChange($event)"
    ></tc-select-search>
    <tc-select-search placeholder="Contact" [multiple]="true" selectedTextFormat="" data-test="supplier-contact-search-field"
      [group]="detailsForm" ctrlName="supplierUserIds"
      [items]="supplierUsers$ | async" bindValue="user_id" bindLabel="fullname" bindHint="primaryemail"
    >
      @if (supplierContactsArchivedWarning$ | async; as warning) {
        <tc-validation-warning [text]="warning" />
      }
    </tc-select-search>
    <tc-select-search placeholder="Buying trader"
      [group]="detailsForm" ctrlName="supplierTraderId"
      [items]="supplierTraders$ | async" bindValue="id" bindLabel="name"
      (change)="supplierTraderChanged$.next($safeNavigationMigration($event?.id))"
    ></tc-select-search>
    <tc-epoch-range-field placeholder="Shipment date range" data-test="shipment-date-field"
      [useUtc]="true"
      [useTemplates]="true"
      [min]="detailsForm.controls.date.value || TODAY"
      [max]="detailsForm.controls.deliveryDatesTo.value"
      [formGroup]="detailsForm"
      startCtrlName="shipmentDatesFrom"
      endCtrlName="shipmentDatesTo"
      tbdCtrlName="shipmentDatesTbd"
      comparisonStartCtrlName="deliveryDatesFrom"
      comparisonEndCtrlName="deliveryDatesTo"
    ></tc-epoch-range-field>
    <mat-form-field gdColumn="span 2">
      <mat-label>Payment Terms</mat-label>
      <input readonly matInput [value]="detailsForm.supplierPaymentTerms$ | async">
    </mat-form-field>
  </div>

  <div class="tc-parties-right" gdColumns="repeat(4, minmax(0, 1fr))" gdGap="15px">
    <tc-select-search placeholder="Buyer" gdColumn="span 2"
      [class.tc-portal-visible]="isBuyerPortalVisible$ | async"
      [group]="detailsForm" ctrlName="buyerId"
      [items]="buyers$ | async" bindValue="id" bindLabel="name"
      (change)="buyerChanged$.next($safeNavigationMigration($event?.id))"
    ></tc-select-search>
    <mat-form-field [formGroup]="detailsForm">
      <mat-label>Buyer ref. number</mat-label>
      <input matInput formControlName="buyerRef" autocomplete="off">
    </mat-form-field>
    <tc-select-search placeholder="Docs Country"
      [group]="detailsForm" ctrlName="docsCountryCode"
      [items]="countries$ | async" bindValue="code" bindLabel="name"
      (change)="onDocsCountryChange()">
      @if (docsCountryIssues$ | async; as issues) {
        <tc-validation-warning [text]="issues" />
      }
    </tc-select-search>

    <tc-select-search placeholder="Destination"
      [group]="detailsForm" ctrlName="destLocationId"
      [items]="locations$ | async" bindValue="location_id" bindLabel="name"
      (change)="onDestLocationChange($event)"
    ></tc-select-search>
    <tc-select-search placeholder="Logistics coordinator"
      [group]="detailsForm" ctrlName="logisticsUserId"
      [items]="coordinators$ | async" bindValue="id" bindLabel="name" bindHint="hint"
    ></tc-select-search>
    <tc-select-search placeholder="Contact" [multiple]="true" selectedTextFormat=""
      [group]="detailsForm" ctrlName="buyerUserIds" data-test="buyer-contact-search-field"
      [items]="buyerUsers$ | async" bindValue="user_id" bindLabel="fullname" bindHint="primaryemail"
    >
      @if (buyerContactsArchivedWarning$ | async; as warning) {
        <tc-validation-warning [text]="warning" />
      }
    </tc-select-search>
    <tc-select-search placeholder="Selling trader"
      [group]="detailsForm" ctrlName="buyerTraderId"
      [items]="buyerTraders$ | async" bindValue="id" bindLabel="name"
      (change)="buyerTraderChanged$.next($safeNavigationMigration($event?.id))"
    ></tc-select-search>
    <tc-epoch-range-field placeholder="Delivery date range" gdColumn="span 2" data-test="delivery-date-field"
      [useUtc]="true"
      [useTemplates]="true"
      [min]="detailsForm.controls.shipmentDatesFrom.value || TODAY"
      [formGroup]="detailsForm"
      startCtrlName="deliveryDatesFrom"
      endCtrlName="deliveryDatesTo"
      tbdCtrlName="deliveryDatesTbd"
      comparisonStartCtrlName="shipmentDatesFrom"
      comparisonEndCtrlName="shipmentDatesTo"
    ></tc-epoch-range-field>
    <mat-form-field gdColumn="span 2">
      <mat-label>Payment Terms</mat-label>
      <input readonly matInput [value]="detailsForm.buyerPaymentTerms$ | async">
    </mat-form-field>
  </div>
</div>

<tc-credit-balance [creditPool]="creditPool$ | async" [balance]="balance$ | async"></tc-credit-balance>

<hr class="fillHR100">

<div class="tc-products">
  @for (product of productsForm?.controls; track product) {
    <div class="tc-deal-product" [formGroup]="product">
      <h5>
        <span>Product {{$index + 1}}</span>
        @if (canRemoveProduct$ | async) {
          <button
            mat-icon-button type="button" (click)="removeProduct($index)">
            <mat-icon class="fa fa-trash-can tc-remove-product"></mat-icon>
          </button>
        }
      </h5>
      <div class="tc-product-info" gdColumns="minmax(0, 4fr) minmax(0, 1fr)" gdGap="15px">
        <tc-product-field gdColumns="repeat(4, minmax(0, 1fr))" gdGap="0 15px"
          [group]="product" ctrlName="productId"
          [suffixCtrl]="product.controls.suffix"
          [protein]="true" (change)="onProductChange()"
        ></tc-product-field>
        <tc-select-search placeholder="Item specification" data-test="item-specification-search-field"
          [group]="product" ctrlName="itemTypeId"
          [items]="itemTypes$ | async" bindLabel="name" bindValue="item_type_id"
        ></tc-select-search>
      </div>
      @if (mode === 'products') {
        <div class="tc-product-params">
          <div gdColumns="minmax(0, 4fr) minmax(0, 2fr) minmax(0, 3fr) minmax(0, 3fr)" gdGap="15px">
            <tc-select-search placeholder="Wrapping"
              [group]="product" ctrlName="wrappingId"
              [items]="wrappings$ | async" bindValue="wrapping_id" bindLabel="name">
            </tc-select-search>
            <tc-select-search placeholder="Weight type"
              [group]="product" ctrlName="weightTypeId"
              [items]="weightTypes$ | async" bindValue="type_id" bindLabel="name">
            </tc-select-search>
            <mat-form-field>
              <mat-label>Brand</mat-label>
              <input matInput formControlName="brand" autocomplete="off">
            </mat-form-field>
            <mat-form-field>
              <mat-label>Product Code</mat-label>
              <input matInput formControlName="productCode" autocomplete="off">
            </mat-form-field>
          </div>
          <div gdColumns="minmax(0, 4fr) minmax(0, 2fr) minmax(0, 3fr) minmax(0, 3fr)" gdGap="15px">
            <mat-form-field>
              <mat-label>No of packages</mat-label>
              <input matInput type="number" min="0" formControlName="packagesCount" autocomplete="off">
            </mat-form-field>
            <tc-select-search placeholder="Type of packages"
              [group]="product" ctrlName="packageId"
              [items]="packageTypes$ | async" bindValue="package_id" bindLabel="name"
            ></tc-select-search>
            <mat-form-field>
              <mat-label>Weight of one package</mat-label>
              <input matInput type="number" min="0" autocomplete="off"
                formControlName="packageSize"
                [matAutocomplete]="packageSize">
              <mat-autocomplete autoActiveFirstOption #packageSize="matAutocomplete">
                @for (option of weights; track option) {
                  <mat-option [value]="option">{{option}}</mat-option>
                }
              </mat-autocomplete>
            </mat-form-field>
            <tc-select-search placeholder="Unit of weight"
              [group]="product" ctrlName="packageMeasureId"
              [items]="measures$ | async" bindValue="measure_id" bindLabel="name"
            ></tc-select-search>
          </div>
          <div gdColumns="minmax(0, 5fr) minmax(0, 1fr)" gdGap="15px">
            <mat-form-field>
              <mat-label>Additional Specifications</mat-label>
              <input matInput formControlName="additionalSpecs" autocomplete="off">
            </mat-form-field>
            <mat-form-field>
              <mat-label>Gross Weight</mat-label>
              <input matInput formControlName="buyerGrossWeight" autocomplete="off" type="number" min="0" autocomplete="off">
            </mat-form-field>
          </div>
        </div>
      }
      <div class="tc-product-params" gdColumns="repeat(2, minmax(0, 1fr))" gdGap="50px">
        <div class="tc-parties-left">
          <h6 fxLayoutAlign="flex-start center" fxLayoutGap="15px">
            <span>Supplier</span>
            <mat-slide-toggle formControlName="supplierLocked" color="primary">LOCK PRICE</mat-slide-toggle>
            <!-- <span class="text-gray" *ngIf="product.supplier.lastPrice">
            Last price: <span>{{product.supplier.lastPrice.price
            | currency:product.supplier.lastPrice.currency_code:'symbol-narrow':'1.4':'no_TH'
          | measure:product.supplier.lastPrice.measure_id}}</span>
        </span> -->
      </h6>
      <div gdColumns="minmax(0, 5fr) minmax(0, 2fr) minmax(0, 5fr)" gdGap="15px">
        <tc-address-field placeholder="Establishment #" [multiple]="true"
          [group]="product" ctrlName="establishments"
          [pickerOptions]="establishmentAddressOptions$(product) | async">
          <div *tcAddressFieldValue="let address = address">
            <div>{{ address.establishment}}@if (address.establishment) {
              <span> – </span>
            }{{ address.name || 'No Name'}}</div>
            <div class="text-gray">{{ address | address:['street1', 'city']}}</div>
          </div>
        </tc-address-field>
        <tc-select-search placeholder="Supplier Incoterm"
          [group]="product" ctrlName="supplierIncotermId"
          [items]="pricingTerms$ | async" bindValue="pricing_terms_id" bindLabel="term"
        ></tc-select-search>
        <tc-select-search placeholder="Supplier Incoterm Location"
          [group]="product" ctrlName="supplierIncotermLocationId"
          [items]="locations$ | async" bindValue="location_id" bindLabel="name"
        ></tc-select-search>
      </div>
      <div gdColumns="repeat(3, minmax(0, 1fr))" gdGap="15px">
        <mat-form-field>
          <mat-label>Weight</mat-label>
          <input matInput type="number" min="0.01" step="0.01" autocomplete="off" data-test="supplier-weight-field"
            formControlName="supplierEstWeight"
            (change)="onSupplierWeightChange($index)"
            [matAutocomplete]="supplierEstWeight">
          <mat-autocomplete autoActiveFirstOption #supplierEstWeight="matAutocomplete" (optionSelected)="onSupplierWeightChange($index)" (optionSelected)="onSupplierWeightChange($index)">
            @for (option of weights; track option) {
              <mat-option [value]="option">{{option}}</mat-option>
            }
          </mat-autocomplete>
        </mat-form-field>
        <tc-select-search placeholder="Unit" data-test="supplier-weight-unit"
          [group]="product" ctrlName="supplierMeasureId"
          (change)="onSupplierMeasureChange($index, $event)"
          [items]="measures$ | async" bindValue="measure_id" bindLabel="name"
        ></tc-select-search>
        <mat-form-field>
          <mat-label>Ind. weight</mat-label>
          <input readonly matInput [value]="supplierIndWeight$(product) | async">
        </mat-form-field>
      </div>
      <div gdColumns="repeat(3, minmax(0, 1fr))" gdGap="15px">
        <mat-form-field>
          <mat-label>Price</mat-label>
          <input matInput type="number" step="0.0001" autocomplete="off" data-test="supplier-price-field"
            formControlName="supplierEstPrice"
            (change)="onSupplierPriceChange(product)">
        </mat-form-field>
        <tc-select-search placeholder="Currency" data-test="supplier-currency-field"
          [group]="detailsForm" ctrlName="supplierCurrencyCode"
          (change)="onCurrencyChange()"
          [items]="currencies$ | async" bindValue="code" bindLabel="code"
        ></tc-select-search>
        <mat-form-field>
          <mat-label>Ind. price</mat-label>
          <input readonly matInput [value]="supplierIndPrice$(product) | async">
        </mat-form-field>
      </div>
      @if (formulaBarState$ | call:$index | async; as f) {
        @if (f.canSetSupplier || f.supplierFormula) {
          <div class="form-group">
            <a href="#"
              [style.whiteSpace]="f.supplierFormula ? 'pre' : ''"
              (click)="$event.preventDefault(); showChangeFormula(DealPartyE.supplier, $index)"
            >{{ f.supplierFormula || 'Set Formula Price' }}</a>
            @if (f.supplierProposal; as fp) {
              <span class="tc-fp-chip" [ngClass]="'tc-fp-chip-' + fp.color" data-test="supplier-fp-proposal-chip"
                tabindex="0" [attr.aria-label]="fp.label + ': ' + fp.tooltip"
                [matTooltip]="fp.tooltip" matTooltipPosition="above">
                {{fp.label}}
                <i class="fa fa-circle-info"></i>
              </span>
            }
          </div>
        }
      }
    </div>
    <div class="tc-parties-right tc-parties-right-reduced">
      <h6 fxLayoutAlign="flex-start center" fxLayoutGap="15px">
        <span>Buyer</span>
        <mat-slide-toggle formControlName="buyerLocked" color="primary">LOCK PRICE</mat-slide-toggle>
        <!-- <span class="text-gray" *ngIf="product.buyer.lastPrice">
        Last price: <span>{{product.buyer.lastPrice.price
        | currency:product.buyer.lastPrice.currency_code:'symbol-narrow':'1.4':'no_TH'
        | measure:product.buyer.lastPrice.measure_id">
      </span>
    </span> -->
  </h6>
  <div gdColumns="minmax(0, 5fr) minmax(0, 2fr) minmax(0, 5fr)" gdGap="15px">
    <tc-address-field placeholder="Invoice Address"
      [group]="product" ctrlName="invoiceAddress"
      [pickerOptions]="invoiceAddressOptions$(product) | async"
    ></tc-address-field>
    <tc-select-search placeholder="Buyer Incoterm"
      [group]="product" ctrlName="buyerIncotermId"
      [items]="pricingTerms$ | async" bindValue="pricing_terms_id" bindLabel="term"
    ></tc-select-search>
    <tc-select-search placeholder="Buyer Incoterm Location"
      [group]="product" ctrlName="buyerIncotermLocationId"
      [items]="locations$ | async" bindValue="location_id" bindLabel="name"
    ></tc-select-search>
  </div>
  <div gdColumns="repeat(3, minmax(0, 1fr))" gdGap="15px">
    <mat-form-field>
      <mat-label>Weight</mat-label>
      <input matInput type="number" min="0.01" step="0.01" autocomplete="off" data-test="buyer-weight-field"
        formControlName="buyerEstWeight"
        (change)="onBuyerWeightChange($index)"
        [matAutocomplete]="buyerEstWeight">
      <mat-autocomplete autoActiveFirstOption #buyerEstWeight="matAutocomplete" (optionSelected)="onBuyerWeightChange($index)">
        @for (option of weights; track option) {
          <mat-option [value]="option">{{option}}</mat-option>
        }
      </mat-autocomplete>
    </mat-form-field>
    <tc-select-search placeholder="Unit" data-test="buyer-weight-unit"
      [group]="product" ctrlName="buyerMeasureId"
      (change)="onBuyerMeasureChange($index, $event)"
      [items]="measures$ | async" bindValue="measure_id" bindLabel="name"
    ></tc-select-search>
    <mat-form-field>
      <mat-label>Ind. weight</mat-label>
      <input readonly matInput [value]="buyerIndWeight$(product) | async">
    </mat-form-field>
  </div>
  <div gdColumns="repeat(3, minmax(0, 1fr))" gdGap="15px">
    <mat-form-field>
      <mat-label>Price</mat-label>
      <input matInput type="number" step="0.0001" autocomplete="off" data-test="buyer-price-field"
        formControlName="buyerEstPrice"
        (change)="onBuyerPriceChange(product)">
    </mat-form-field>
    <tc-select-search placeholder="Currency" data-test="buyer-currency-field"
      [group]="detailsForm" ctrlName="buyerCurrencyCode"
      (change)="onCurrencyChange()"
      [items]="currencies$ | async" bindValue="code" bindLabel="code"
    ></tc-select-search>
    <mat-form-field>
      <mat-label>Ind. price</mat-label>
      <input readonly matInput [value]="buyerIndPrice$(product) | async">
    </mat-form-field>
  </div>
  @if (formulaBarState$ | call:$index | async; as f) {
    @if (f.canSetBuyer || f.buyerFormula) {
      <div class="form-group">
        <a href="#"
          [style.whiteSpace]="f.buyerFormula ? 'pre' : ''"
          (click)="$event.preventDefault(); showChangeFormula(DealPartyE.buyer, $index)"
        >{{ f.buyerFormula || 'Set Formula Price' }}</a>
            @if (f.buyerProposal; as fp) {
              <span class="tc-fp-chip" [ngClass]="'tc-fp-chip-' + fp.color" data-test="buyer-fp-proposal-chip"
                tabindex="0" [attr.aria-label]="fp.label + ': ' + fp.tooltip"
                [matTooltip]="fp.tooltip" matTooltipPosition="above">
                {{fp.label}}
                <i class="fa fa-circle-info"></i>
              </span>
            }
      </div>
    }
  }
</div>
</div>
</div>
}

<tc-deal-totals-v2 [mode]="mode" [dealDetails]="detailsForm"></tc-deal-totals-v2>

@if (!mode) {
  <div gdColumns="minmax(0, 1fr) minmax(0, 2fr) minmax(0, 3fr)">
    <div>
      @if (canAddProduct$ | async) {
        <button mat-button type="button" (click)="addProduct()">
          <i class="fa fa-plus" aria-hidden="true"></i> ADD PRODUCT
        </button>
      }
    </div>
    <div style="text-align: right">
      <button mat-button type="button" [disabled]="!dealId" (click)="showEditSupplierInstructions()">
        <i class="fa fa-20 fa-file-plus" alt="icon"></i>&nbsp;
        @if (!(hasSupplierInstructions$ | async)) {
          <span>ADD SUPPLIER SPECIAL INSTRUCTIONS</span>
        }
        @if (hasSupplierInstructions$ | async) {
          <span>EDIT SUPPLIER SPECIAL INSTRUCTIONS</span>
        }
      </button>
      @if (hasSupplierInstructions$ | async; as supplierInstructions) {
        <p style="padding-right: 10px">{{supplierInstructions.body}}</p>
      }
    </div>
    <div>
      <button mat-button type="button" [disabled]="!dealId" (click)="showEditBuyerInstructions()">
        <i class="fa fa-20 fa-file-plus" alt="icon"></i>&nbsp;
        @if (!(hasBuyerInstructions$ | async)) {
          <span>ADD BUYER SPECIAL INSTRUCTIONS</span>
        }
        @if (hasBuyerInstructions$ | async) {
          <span>EDIT BUYER SPECIAL INSTRUCTIONS</span>
        }
      </button>
      @if (hasBuyerInstructions$ | async; as buyerInstructions) {
        <p style="padding-left: 10px">{{buyerInstructions.body}}</p>
      }
    </div>
  </div>
}
</div>

@if (!mode) {
  <div class="tc-deal-costs">
    <header (click)="$event.detail === 3 ? primaryCostsVisible = !primaryCostsVisible : ''">Deal costs</header>
    <tc-costs-list [types]="primaryCostsVisible ? ['primary', 'secondary', 'tertiary'] : ['secondary', 'tertiary']"
      [units]="productsForm.controls[0].controls.supplierMeasureId.value"
      [dealViewRaw]="dealViewRaw$ | async"
      [costsForm]="costsForm"
      [creditNotes]="creditNotes$ | async"
      [vendorCredits]="vendorCredits$ | async"
      [fxRates]="fxRates$ | async"
      [fxRatesRange]="fxRatesAskRange$ | async"
      (updateCost)="updateCost.next($event)"
      (removeCost)="removeCost.next($event)"
    ></tc-costs-list>
  </div>
}

@if (mode !== 'products') {
  <div class="tc-deal-footer">
    <tc-trading-summary
      [dealForm]="dealForm"
      [dealViewRaw$]="dealViewRaw$"
    ></tc-trading-summary>
    <tc-shipping-summary-v2 class="summary" [formGroup]="detailsForm"
      [invoices]="(dealViewRaw$ | async)?.invoices || []"
    ></tc-shipping-summary-v2>
  </div>
}
